import { render, staticRenderFns } from "./card-typing.vue?vue&type=template&id=64305c13&scoped=true"
import script from "./card-typing.vue?vue&type=script&lang=js"
export * from "./card-typing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64305c13",
  null
  
)

export default component.exports